import React from 'react';
import {useField} from 'formik';

import CircleButton from './circle-button';

interface Props {
  closePopover: () => void;
}

const gradesFirstSection = ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+'];
const gradesSecondSection = ['C', 'C-', 'D+', 'D', 'D-', 'F'];

const LetterGradePicker = ({closePopover}: Props) => {
  const [gradeInput, , gradeInputHelpers] = useField('grade.gradeInput');
  const [, , gradeTypeHelpers] = useField('grade.gradeType');

  const makeButton = (val: string, index: number) => (
    <div className="course-letter-grade-picker-bubble" key={`${val}-${index}`}>
      <CircleButton
        size={35}
        selected={val === gradeInput.value}
        testId={val}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();

          gradeInputHelpers.setValue(val);
          gradeTypeHelpers.setValue('L');
          closePopover();
        }}
      >
        {val}
      </CircleButton>
    </div>
  );

  return (
    <div className="course-letter-grade-picker">
      <div className="course-letter-grade-picker-first-row prefix-flex prefix-align-items prefix-justify-content">
        {gradesFirstSection.map(makeButton)}
      </div>
      <div className="course-letter-grade-picker-second-row prefix-flex prefix-align-items prefix-justify-content">
        {gradesSecondSection.map(makeButton)}
      </div>
    </div>
  );
};

export default LetterGradePicker;
